// Client-side pooling for the admin Reporting "AHT by account per rep"
// section's Total row (per period) and grand Total row (across every shown
// period) -- both need to react instantly to the agent-filter selection with
// no re-fetch, so the pooling has to happen here rather than server-side
// (see getAhtByAccountPerRepReport's own module comment).
//
// Same "reconstruct each row's total ms from its already-divided average
// times its count, sum those, divide once" rule as
// ui/src/MyStatsPage.jsx's totalAht() -- never an average of the per-agent
// averages, which would weight a slow, low-volume agent/period the same as
// a busy one.

// agentRows: [{ totalContacts, combinedAht, byAccount: { [account]: { contacts, aht } } }]
// -- one period's agents array (already filtered to the selected agents), or
// every selected agent across every shown period flattened into one list,
// for the grand Total. accountKeys: the fixed account codes to break out
// (e.g. ['1A_EBAY', 'AM_EBAY']).
//
// Returns { totalContacts, combinedAht, byAccount } in the same shape as one
// agent row, so the Total/grand-Total rows render through the same cells.
// combinedAht/byAccount[...].aht are null when there are zero contacts to
// pool -- never a fabricated 0, which would read as "0ms average" instead of
// "nothing to measure."
export function poolAgentRows(agentRows, accountKeys) {
  let sumMs = 0
  let count = 0
  for (const row of agentRows) {
    if (row.totalContacts > 0) {
      sumMs += row.combinedAht * row.totalContacts
      count += row.totalContacts
    }
  }

  const byAccount = {}
  for (const account of accountKeys) {
    let accSumMs = 0
    let accCount = 0
    for (const row of agentRows) {
      const cell = row.byAccount[account]
      if (!cell || cell.contacts === 0) continue
      accSumMs += cell.aht * cell.contacts
      accCount += cell.contacts
    }
    byAccount[account] = { contacts: accCount, aht: accCount > 0 ? accSumMs / accCount : null }
  }

  return { totalContacts: count, combinedAht: count > 0 ? sumMs / count : null, byAccount }
}
